module.exports = __webpack_public_path__ + "static/media/Rubaiat Habib.bad3cf25.png";